/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Container = require('./Container'),
    LinkedStateMixin = require('react/lib/LinkedStateMixin');

var DragAroundCustom = React.createClass({displayName: 'DragAroundCustom',
  mixins: [LinkedStateMixin],

  getInitialState:function() {
    return {
      snapToGrid: false
    };
  },

  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Container, {snapToGrid: this.state.snapToGrid}), 
        React.createElement("p", null, 
          React.createElement("input", {type: "checkbox", 
                 checkedLink: this.linkState('snapToGrid')}, 
            "Snap to grid"
          )
        ), 
        React.createElement("hr", null), 
        React.createElement("p", null, 
          "Browser APIs provide no way to change drag preview or its behavior once drag has started." + ' ' +
          "Libraries such as jQuery UI implement drag and drop from scratch to work around this, but react-dnd" + ' ' +
          "only supports browser drag and drop “backend” for now, so we have to accept its limitations."
        ), 
        React.createElement("p", null, 
          "We can, however, customize behavior a great deal if we feed the browser an empty image as drag preview," + ' ' +
          "and move the dragged DOM element itself continuously in response to dragover event."
        ), 
        React.createElement("p", null, 
          "With this approach, we miss out on default “return” animation when dropping outside the container." + ' ' +
          "However, we get great flexibility in customizing drag feedback and zero flicker."
        )
      )
    );
  }
});

module.exports = DragAroundCustom;


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-custom/index.js
 ** module id = 135
 ** module chunks = 0
 **/